<body class="ltr main-body leftmenu">

    <!-- Main Content-->
    <div class="main-content side-content pt-0 ml-0">
        <div class="main-container container-fluid">
            <div class="inner-body" [formGroup]="subjectMappingForm">
                <!-- Page Header -->
                <div class="page-header">
                    <div>
                        <h2 class="main-content-title tx-18 mg-b-5">
                            Subjects Data </h2>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active" aria-current="page"> Subjects Mapping
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">
                                Subjects Mapping </li>
                        </ol>
                    </div>
                    <div class="d-flex">
                        <div class="justify-content-center">
                            <button type="button" class="btn btn-primary my-2 btn-icon-text floatright">
                                <!--  (click)="addnewrecord('true')" -->
                                Add New Record
                            </button>
                            <button type="button" class="btn btn-primary my-2 me-2  btn-icon-text floatright">
                                <!-- (click)="download()" -->
                                <i class="fe fe-download-cloud me-2"></i>
                                Download Report
                            </button>

                            <button mat-button [matMenuTriggerFor]="menu" type="button"
                                class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                data-toggle="dropdown">
                                <i class="fe fe-filter me-2"></i> Doc Type
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item>.csv</button>
                                <button mat-menu-item>pdf</button>
                            </mat-menu>
                            <!-- <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
                                <i class="fe fe-download me-2"></i> Import
                            </button> -->

                        </div>
                    </div>
                </div>
                <!-- End Page Header -->

                <!-- Row -->

                <!-- add of faculty start  -->
                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" novalidate>
                        <div class="col-lg-12 col-md-12">

                            <div class="card custom-card">
                                <div class="card-body">
                                    <div>
                                        <!-- <h3 class="main-content-label mb-1"><b>
                                        Add New Town Record  </b></h3> -->
                                        <p class="text-muted card-sub-title mb-0">Subject Mapping Information </p>
                                    </div>
                                    <!-- <div >
                                    <h3 class="main-content-label mb-1"><b> UpdateTownRecord  </b></h3>
                                    <p class="text-muted card-sub-title mb-0"> UpdateSelectedTownInformation  </p>
                                </div>
                                <div >
                                    <h3 class="main-content-label mb-1"><b> DeleteTownRecord  </b></h3>
                                    <p class="text-muted card-sub-title mb-0"> DeleteSelectedTownInformation  </p>
                                </div>   -->
                                    <div class="row mt-3 clearfix">

                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">

                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label> Course</mat-label>
                                                        <mat-select #select22 placeholder="CoCode" class="colorblack"
                                                            formControlName="course">
                                                            <mat-select-filter *ngIf="select22.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="courseList"
                                                                (filteredReturn)=" courseFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  courseFilterList"
                                                                [value]="item.CoCode"
                                                                (click)="fetchExamRelatedCourse(item.CoCode)" >
                                                                {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="isShownExamDiv==true" class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">

                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label> Exam</mat-label>
                                                        <!-- <input matInput formControlName="CoMediums" placeholder="Course Mediums" > -->
                                                        <mat-select #select23 class="colorblack"
                                                            formControlName="course">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmCoCode'"
                                                                [array]="examCourseList"
                                                                (filteredReturn)=" examCourseFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  examCourseFilterList"
                                                                [value]="item.EmCoCode" (click)="fetchMapsubForGrid(item.EmId)">
                                                                {{item.EmName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>


                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="isDivShow==true" class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">

                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label> Stream</mat-label>
                                                        <!-- <input matInput formControlName="CoMediums" placeholder="Course Mediums" > -->
                                                        <mat-select #select223 class="colorblack"
                                                            formControlName="stream">
                                                            <mat-select-filter *ngIf="select223.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'StrCode'"
                                                                [array]="exStreamList"
                                                                (filteredReturn)=" examStreamFilterList =$event"></mat-select-filter>
                                                            <mat-option
                                                                *ngFor="let item of  examStreamFilterList"
                                                                [value]="item.StrCode">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>


                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="istableShow==true" class="col-sm-12">

                                            <div class="table-responsive">
                                    <table id="datatable" class="table table-striped table-bordered text-nowrap text-left">
                                        <thead>
                                            <tr>
                                            
                                                <th  class="f600" width="15%">
                                                    Sub
                                                </th>
                                                <th  class="f600">
                                                   Short Name  
                                                </th>
                                                <th  class="f600">
                                                    Type
                                                 </th>
                                                 <th  class="f600">
                                                   Map To 
                                                 </th>
                                                 <th  class="f600">
                                                    Short Name  
                                                 </th>
                                                 <th  class="f600">
                                                    Exam
                                                 </th>
                                                <!-- <th  class="f600" width="15%">
                                                    Code  
                                                </th> -->
                                                <!-- <th>Status</th>
                                                <th>Type</th> -->
                                                <th  class="f600 text-center" width="10%" >
                                                    Action </th>
                                            </tr>
                                        </thead>
                                        <tbody *ngFor="let data of mapSubjectList" id="table_data">
                                            <tr  style="cursor:pointer;" >
                                            
                                                <td  > {{data.EsCode}}</td>
                                                <td  >{{data.EsShName}} </td>
                                                <td  > {{data.EsMapType}} </td>
                                                <td  >{{data.EsCode}}</td>
                                                <td  > {{data.ShName}}</td>
                                                <td  >{{data.EmCode}} </td>
                                                <!-- <td>{{course.DsName}} </td> -->
                                                 <td class="text-center">  
                                                    <a class="btn-floating" title="Edit" (click)="openBranchPopUp(data)" >
                                                        <i class="fa fa-edit"></i>
                                                    </a>
                                                    <!-- <a class="btn-floating" title="Delete" >
                                                        <i class="fas fa-trash"></i>
                                                    </a> -->
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                        </div>
                                        <!-- <div *ngIf="isDivShow==true" class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">

                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label> Sub</mat-label>
                                                        <input matInput formControlName="subject"
                                                            placeholder="Course Mediums">

                                                    </mat-form-field>


                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="isDivShow==true" class="col-sm-4">
                                            <div class="form-group">
                                                <div class="">

                                                    <mat-radio-group formControlName="optionlCompalsary"
                                                        class="example-full-width" >
                                                        <div class="row">
                                                            <div class="col-sm-3 "></div>
                                                            <div class="col-sm-3 p-1  mt-3">
                                                                <mat-radio-button value="C">Comp</mat-radio-button>
                                                            </div>
                                                            <div class="col-sm-1 p-1  mt-3"></div>
                                                            <div class="col-sm-3 p-1 mt-3">
                                                                <mat-radio-button value="O">Option</mat-radio-button>
                                                            </div>

                                                        </div>
                                                    </mat-radio-group>


                                                </div>
                                            </div>
                                        </div>
                                     <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width" >
                                                    <mat-label>Map to</mat-label>
                                                    <mat-select #select223 class="colorblack"
                                                    formControlName="mapto">
                                                    <mat-option value="m">Maths</mat-option>
                                                    <mat-option value="p">Physics</mat-option>
                                                    <mat-option value="c">Chemistry</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                     </div> -->
                                     

                                      
                                        
                                      
                                        <div class="col-sm-12">
                                            
                                            <button type="submit"
                                                class="btn btn-primary my-2 me-2  btn-icon-text floatright  btn-raised g-bg-blush2">
                                 
                                                    Submit
                                            </button>
                                            <button type="submit" (click)="back()"
                                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base">
                                               
                                                    Back
                                                
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</body>

<!-- [dataSource]="dataSource" -->